import { render, staticRenderFns } from "./FormInternalRemarks.vue?vue&type=template&id=648025e6&"
import script from "./FormInternalRemarks.vue?vue&type=script&lang=js&"
export * from "./FormInternalRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCheckbox,VSheet})
